import React, {
  createContext,
  PropsWithChildren,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useHistory } from 'react-router-dom';

export const ResourceTriageContext = createContext({
  type: '',
  id: '',
  tab: '',
  onResourceChange: (type: string, id: string) => {},
});

export type ResourceDataType = { type: string; id: string; tab: string };

export function ResourceTriageContextProvider({ children }: PropsWithChildren<any>) {
  const history = useHistory();
  const initialParams = new URLSearchParams(history.location.search);
  const id = initialParams.get('id');
  const type = initialParams.get('type');
  const tab = initialParams.get('tab');
  const [data, setData] = useState<ResourceDataType>({ type, id, tab });

  function updateUrl(data: ResourceDataType) {
    const params = new URLSearchParams();
    params.set('type', data.type);
    params.set('id', data.id);
    history.replace({
      pathname: history.location.pathname,
      search: params.toString(),
    });
  }

  useEffect(() => {
    if (id) {
      onResourceChange(type, id, tab);
    }
  }, [id, type]);

  const onResourceChange = useCallback((resourceType: string, resourceId: string, tab = '') => {
    setData({ type: resourceType, id: resourceId, tab });
    updateUrl({ type: resourceType, id: resourceId, tab });
  }, []);

  const value = useMemo(() => {
    return {
      ...data,
      onResourceChange,
    };
  }, [data, onResourceChange]);

  return <ResourceTriageContext.Provider value={value}>{children}</ResourceTriageContext.Provider>;
}
